import React, { Component } from "react";
import WidgetPageRenderer from "../widgets/WidgetPageRenderer";

import LoadingOverlay from "./LoadingOverlay";
export default class Resource_permissions_NEW extends Component {
  render() {
    return <WidgetPageRenderer pageRoute="resource_permissions" />;
  }
}
